// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"87ba2555","291":"5cfc6850"}[chunkId] + ".js";
};